import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {makeStyles} from "tss-react/mui";
import {ALERT, sidebarWidth} from "../resources/environment";
import {useSidebarLayout} from "./sidebar/Context/SidebarProvider";
import {useRexAI} from "../context/RexAIProvider";
import {TOP_BAR_HEIGHT} from "../resources/theme";

const useMainStyles = makeStyles()((theme, {isSidebarExpanded, agentPanelState}) => ({
  content: {
    paddingLeft:
      (isSidebarExpanded ? sidebarWidth.open : sidebarWidth.collapsed) +
      (agentPanelState === "conversation" ?
        sidebarWidth.agentPanelConversation :
        agentPanelState === "list" ?
          sidebarWidth.agentPanelList :
          0),
    transition: theme.transitions.create("padding", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    flexGrow: 1,
    zIndex: theme.zIndex.drawer,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
    },
    "@media print": {
      paddingLeft: 0,
    },
  },
}));

const Main = ({children}) => {
  const {isSidebarExpanded} = useSidebarLayout();
  const {agentPanelState} = useRexAI();
  const {classes} = useMainStyles({isSidebarExpanded, agentPanelState});

  useEffect(() => {
    ALERT.success("Welcome!");
  }, []);

  return (
    <main
      className={classes.content}
      id="main"
      style={{
        "--top-bar-offset": `${TOP_BAR_HEIGHT}px`,
      }}
    >
      {children}
    </main>
  );
};

Main.propTypes = {
  children: PropTypes.object,
};

export default Main;
